<template>
  <div class="demo-spin-article report__table">
    <div class="ls_action_header">
      <Row :gutter="24" type="flex" class="ls_action_header mb-30">
        <Col :xs="24" :sm="12" :md="12" :lg="0"
        ><Select
          class="mb-10 select-box"
          v-model="filter.cash"
          placeholder="Касса"
        >
          <Option
            v-for="item in filterOptions.cash"
            :value="item.cashId"
            :key="item.cashId"
          >{{ item.name }}
          </Option>
        </Select></Col
        >
        <Col :xs="24" :sm="12" :md="12" :lg="0"
        ><DatePicker
          v-model="filterOpenDate"
          @on-change="changeFilterOpenDate"
          @on-clear="clearFilterOpenDate"
          format="dd.MM.yyyy"
          type="daterange"
          :start-date="currentDate"
          placeholder="Дата открытия"
          :clearable="false"
        ></DatePicker
        ></Col>
      </Row>
    </div>
    <!-- DATA TABLE + PAGINATION -->
    <Table
      :show-header="false"
      :loading="loading"
      :columns="columns"
      :data="data"
      style="overflow: visible"
      @on-sort-change="changeSorting"
      @on-selection-change="onSelectChange"
    ></Table>
<!--    <Page-->
<!--      :total="totalRecords"-->
<!--      :page-size="pageSize"-->
<!--      :page-size-opts="[12, 24, 30]"-->
<!--      @on-change="changePage"-->
<!--      @on-page-size-change="changePageSize"-->
<!--      show-sizer-->
<!--      :styles="{ marginTop: '30px', float: 'right' }"-->
<!--    />-->

<!--    &lt;!&ndash; ITEM VIEW &ndash;&gt;-->
<!--    <shiftItem-->
<!--      :id="item.id"-->
<!--      :action="item.action"-->
<!--      v-model="item.show"-->
<!--      @reload-table="fetchItems"-->
<!--      :base_view_url="baseViewUrl"-->
<!--      :item_type="item_type"-->
<!--    ></shiftItem>-->

    <Modal v-model="modalReport" title="Отчет" width="300" cancelText="Закрыть" okText="Печать">
      <div class="report_body">{{ reportText }}</div>
    </Modal>
  </div>
</template>
<script>
import {
  formatNumber,
  formatDate,
  formatDateTime
} from "../../base/base_func.js";
import { base_url } from "../../http.js";
import { BaseTableData } from "../../base/base_table.js";
import ticketHistoryExpand from "./ticketHistoryExpand";

const REPORT = {
  Z_REPORT: "z_report",
  SECTION_REPORT: "section_report",
  CASHIER_REPORT: "cashier_report",
  CONTROL_TAPE: "control_tape"
};

let _app = BaseTableData();
_app.components = {
  ticketHistoryExpand
};

_app.data = function() {
  return {
    // Base settings
    baseViewUrl: base_url + "/proxy/shifts/",
    // item_type: "reports",
    loading: true,

    // Table settings
    columns: [
      {
        type: "expand",
        width: 50,
        render: (h, params) => {
          return h(ticketHistoryExpand, {
            props: {
              shift_id: params.row.shiftId
            }
          });
        }
      },
      {
        title: "№ смена",
        // width: 340,
        key: "shiftNumber",
        // sortable: true,
        render: (h, params) => {
          return h("span", {
              style: {
                  fontWeight: 'bold'
              }
          }, `Смена №${params.row.shiftNumber}`);
        }
      }
    ],
    data: [],
    lastDraw: 0,
    // totalRecords: null,
    // currentPage: 1,
    // pageSize: 12,
    // sorting: "",
    // searchString: "",

    // filterShow: false,
    filter: {
      cash: "",
      open_date__gt: "",
      open_date__lt: ""
    },
    filterOptions: {
      cash: []
    },

    filterOpenDate: ["", ""],
    selected: [],

    modalReport: false,
    reportText: "",

    // item: {
    //   show: false,
    //   id: null,
    //   action: null
    // }
  };
};

_app.computed.fetchParams = function() {
  let params = {
    draw: this.lastDraw,
    // offset: this.start,
    // limit: this.pageSize,
    // search: this.searchString,
    // ordering: this.sorting
  };

  for (let key in this.filter) {
    if (this.filter[key]) {
      params[key] = this.filter[key];
    }
  }

  return params;
};

_app.computed.currentDate = function(){
  let date = new Date();
  date.setMonth(date.getMonth() - 1);
  return date;
};


_app.methods.showReportAction = function(report_type, shift_id) {
  return () => {
    if (report_type === REPORT.CONTROL_TAPE) {
      this.fetchReportPdf(shift_id, report_type);
    } else {
      this.fetchReportText(shift_id, report_type);
      // console.log(report_type);
      // console.log(shift_id);
    }
  };
};

_app.methods.changeFilterOpenDate = function(date_arr, date_obj) {
  if (date_arr[0] && date_arr[1]) {
    this.filter.open_date__gt = this.filterOpenDate[0];
    this.filter.open_date__lt = this.filterOpenDate[1];
  }
};
// Очистка полей поиска даты документа (Order date), после чего срабатывает watcher и обновляются данные в таблице
_app.methods.clearFilterOpenDate = function(date_arr, date_obj) {
  this.filter.open_date__gt = "";
  this.filter.open_date__lt = "";
};

_app.methods.formatNumber = function(number) {
  return formatNumber(number);
};

_app.methods.fetchCash = function() {
  const url = base_url + "/proxy/cashboxes/";
  this.$http
    .get(url)
    .then(result => {
      this.filterOptions.cash = result.data;
      this.filter.cash = result.data[0].cashId;
    })
    .catch(error => {
      this.$Message.error("Произошла ошибка");
    });
};

// Загружаем данные для таблицы
_app.methods.fetchItems = function() {
  this.loading = true;
  this.lastDraw++;
  let cashbox_id = this.filter.cash;
  let url = `${base_url}/proxy/cashboxes/${cashbox_id}/shifts/`;
  this.$http
    .get(url, {
      params: this.fetchParams
    })
    .then(result => {
      // if (result.data.draw === this.lastDraw) {
      this.data = result.data;
      // this.totalRecords = result.data.count;
      // }
    })
    .finally(() => {
      this.loading = false;
    });
};

_app.methods.b64DecodeUnicode = function(str) {
  // Going backwards: from bytestream, to percent-encoding, to original string.
  return decodeURIComponent(
    atob(str)
      .split("")
      .map(function(c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );
};

_app.methods.fetchReportText = function(shift_id, report_type) {
  const url = `${this.baseViewUrl}${shift_id}/${report_type}/`;
  this.reportText = "";
  this.$http
    .get(url)
    .then(result => {
      this.reportText = this.b64DecodeUnicode(result.data.report);
      this.modalReport = true;
      // console.log(this.reportText);
      // this.filterOptions.cash = result.data.results;
    })
    .catch(error => {
      this.$Message.error("Произошла ошибка");
    });
};

_app.methods.fetchReportPdf = function(shift_id, report_type) {
  // window.onbeforeunload = function () {};
  //
  // location.href = base_url + "/product_order/pdf/";
  //
  // window.onbeforeunload = function () {
  //   return "Вы уверены, что хотите закрыть приложение?";
  // };

  const url = `${this.baseViewUrl}${shift_id}/${report_type}/`;
  this.$http({
    url: url,
    method: "GET",
    responseType: "blob" // important
  })
    .then(response => {
      const blob = new Blob([response.data], { type: "application/pdf" });

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      // the filename you want
      // console.log(response);
      // let headerLine = response.headers['content-disposition'];
      // let startFileNameIndex = headerLine.indexOf('"') + 1;
      // let endFileNameIndex = headerLine.lastIndexOf('"');
      // let filename = headerLine.substring(startFileNameIndex, endFileNameIndex);

      // a.download = `${this.doc_templates_obj[type]}.pdf`;
      a.download = `ControlTapeReport.pdf`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    })
    .catch(error => {
      this.$Message.error("Произошла ошибка. Попробуйте позже.");
      console.log(error + 'Ошибка');
    });
};

_app.methods.setInitialDates = function () {
  let start_date = new Date();
  let end_date = new Date();

  start_date.setDate(start_date.getDate() - 7).toString();

  this.filterOpenDate[0] = start_date;
  this.filterOpenDate[1] = end_date;

  this.filter.open_date__gt = start_date;
  this.filter.open_date__lt = end_date;
};
_app.created = function() {
  this.setInitialDates();
  this.fetchCash();
};

export default _app;
</script>

<style scoped>
.report_body {
  /*width: 420px;*/
  box-sizing: border-box;
  color: rgb(0, 0, 0);
  font-family: Consolas, serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 15px;
  overflow-wrap: break-word;
  pointer-events: auto;
  text-align: left;
  white-space: pre-wrap;
}

.select-box {
  width: 220px;
}

@media screen and (max-width: 991px) {
  .select-box {
    width: 100%;
  }
}


</style>


<style>

  .datepicker_input, .ivu-date-picker input {
    max-width: 260px;
    width: 260px;
  }


  @media screen and (max-width: 991px) {
    .datepicker_input, .ivu-date-picker, .ivu-date-picker input {
      max-width: 100%;
      width: 100%;
    }
  }

  @media screen and (max-width: 767px) {
    .ivu-table-tip table {
      min-height: 50vh;
    }
  }


  @media screen and (min-width: 992px) {
    .ivu-col-span-lg-0 {
      display: block;
      width: auto;
    }
  }

</style>



// WEBPACK FOOTER //
// src/apps/money_order/ticketHistory.vue